import { useIntl } from 'react-intl';
import { PropTypes } from 'prop-types';
import './iconsEffect.css';

const TemplateTable = ({
  regions,
  onClick,
  selectedRegion,
  unLockedRegion,
  onClickLock,
}) => {
  const intl = useIntl();
  return (
    <div
      className="select-multiple"
      style={{
        maxHeight: 'none',
      }}
    >
      <label style={{ textTransform: 'uppercase', fontSize: '12px' }}>
        {intl.formatMessage({ id: 'selectedFields' })}
      </label>
      <ul>
        {regions.map((region) => {
          return (
            <li
              key={`formTable-li-${region.index}`}
              id={`formTable-li-${region.index}`}
            >
              <div
                className="row"
                style={
                  selectedRegion === region.data
                    ? {
                        backgroundColor: 'rgba(240, 150, 0, 0.6)',
                      }
                    : {}
                }
              >
                <input
                  onChange={() => {}}
                  checked={false}
                  type="checkbox"
                  id={`formTable-input-${region.index}`}
                  value={region.index}
                />

                <label
                  onClick={(event) => onClick(event, region)}
                  id={`formTable-label-${region.index}`}
                >
                  {intl.formatMessage({ id: `attr.${region.data}` })}
                  <div
                    style={{ padding: '0px' }}
                    className="col-xs-1 col-sm-1 col-md-1"
                  >
                    {unLockedRegion === region.data ? (
                      <i
                        onClick={() => onClickLock(region.data)}
                        className="icon fas fa-unlock-alt iconRed fa-lg"
                      />
                    ) : region.isVisible ? (
                      <i
                        onClick={() => onClickLock(region.data)}
                        className="icon fas fa-lock iconGreen fa-lg"
                      />
                    ) : (
                      <i
                        onClick={() => onClickLock(region.data)}
                        className="icon fas fa-lock iconGray fa-lg"
                      />
                    )}
                  </div>
                </label>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

TemplateTable.propTypes = {
  regions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onClick: PropTypes.func.isRequired,
  selectedRegion: PropTypes.string.isRequired,
  unLockedRegion: PropTypes.string.isRequired,
  onClickLock: PropTypes.func.isRequired,
};

export default TemplateTable;
